// api/v1/templates/metrics?brand_id=4

import AspApi from "api/ApiConfig";

// campaign list
export const campaignList = async (brandId, query) => {
  let qpm = [];

  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.status) qpm.push(`status=${query?.status}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "" + qpm.join("&");

  const res = await AspApi.get(
    `api/v1/campaigns/metrics?brand_id=${brandId}&${qpmString}`
  );
  return res;
};

// overall metrix
export const metrix = async (brandId) => {
  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/template_utils/template_metrics?brand_id=${brandId}`
  );
  return res;
};

// conversation metrix
export const conversationMetrix = async (brandId, query) => {
  let qpm = [];

  if (brandId) qpm.push(`brand_id=${brandId}`);
  if (query.year) qpm.push(`year=${query.year}`);
  if (query.month) qpm.push(`month=${query.month}`);

  let qpmString = "";
  if (qpm.length > 0) qpmString = "?" + qpm?.join("&");

  const res = await AspApi.get(`/api/v1/home/conversation/metrics${qpmString}`);
  return res;
};

// summary

export const conversationSummaryApi = async (query) => {
  let qpm = [];

  if (query.brand_id) qpm.push(`brand_id=${query.brand_id}`);
  if (query.start_date) qpm.push(`start_date=${query.start_date}`);
  if (query.end_date) qpm.push(`end_date=${query.end_date}`);

  let qpmString = "";
  if (qpm.length > 0) qpmString = "?" + qpm?.join("&");

  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/conversations/conversation_summary${qpmString}`
  );
  return res;
};

export const conversationPerformanceApi = async (query) => {
  let qpm = [];

  if (query.brand_id) qpm.push(`brand_id=${query.brand_id}`);
  if (query.recent_campaign_count)
    qpm.push(`recent_campaign_count=${query.recent_campaign_count}`);

  let qpmString = "";
  if (qpm.length > 0) qpmString = "?" + qpm?.join("&");

  const res = await AspApi.get(
    `/api/v1/campaign_utils/campaign_performance${qpmString}`
  );
  return res;
};

export const whatsappBusinessNumbers = async (brandId, params) => {
  let qpm = [];
  qpm.push(`brand_id=${params?.brand_id}`);

  if (params?.call_meta === 'false') qpm.push(`call_meta=${params?.call_meta}`);

  let qpmString = "";
  if (qpm.length > 0) qpmString = "?" + qpm?.join("&");

  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/whatsapp_numbers${qpmString}`
  );
  return res;
};
